import "./modifyCharityCardDataPassport.scss";

// @vendor
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
const storage = require("utilities/storage");

// @components
const { OKSectionBox } = require("commonsComponents/OKSectionBox");
const { OKBoxTitle } = require("commonsComponents/OKBoxTitle");
const OKLoadingErrorMessage = require("components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage");
import OkNgoSearcher from "okNGOSelector/okNgoSearcher/okNgoSearcher";

// @actions
import { setNGOsData } from "actions/okWizardSolidarity";

// @images
const firstIcon = require("assets/icons/solidarity-info-icon.svg");
const secondIcon = require("assets/icons/solidarity-donations-icon.svg");
const thirdIcon = require("assets/icons/solidarity-advantages-icon.svg");

const environmentConfig = require("core/environmentConfig");

// @utils
import { i18n } from "core/i18n";
const usd = require('utilities/usd');
const { formatText, FormattedText } = i18n;

//constants
const { CARD } = require('constants/ngoCategoryContexts');

class ModifyCharityCardDataPassport extends Component {
    getSelectedNgos = () => {
        const { ngos } = this.props;

        if (ngos) {
            return ngos.map(item => {
                return item.ngoId;
            });
        }
    };

    handleNGOList = ngosData => {
        const { setNGOsData } = this.props;

        setNGOsData(ngosData);
    };

    render() {
        const { originCountry, ngos } = this.props;

        const interactionId = usd.getInteractionId();
        const ngosSelected = !ngos ? [] : this.getSelectedNgos()
        const token = storage.cookies.get("tokenCredential");

        return (
            <Fragment>
                <OKBoxTitle
                    value={
                        <FormattedText value="hireSolidarityCard-modifyCharityCardTitle" />
                    }
                    isNotSeparator={true}
                />

                <div className="modify-solidarity-card-passport__subtitle">
                    <FormattedText value="hireSolidarityCard-modifyCharityCardSubtitle" />
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <img
                            className="modify-solidarity-card-passport__img"
                            src={firstIcon}
                        ></img>
                        <OKSectionBox
                            title={
                                <span className="modify-solidarity-card-passport__title">
                                    <FormattedText value="hireSolidarityCard-modifyCharityBoxTitleOne" />
                                </span>
                            }
                            hasShadow={false}
                            className="modify-solidarity-card-passport__text"
                        >
                            <FormattedText value="hireSolidarityCard-modifyCharityBoxDescriptionOne" />
                        </OKSectionBox>
                    </div>
                    <div className="col-xs-4">
                        <img
                            className="modify-solidarity-card-passport__img"
                            src={secondIcon}
                        ></img>
                        <OKSectionBox
                            title={
                                <span className="modify-solidarity-card-passport__title">
                                    <FormattedText value="hireSolidarityCard-modifyCharityBoxTitleTwo" />
                                </span>
                            }
                            hasShadow={false}
                            className="modify-solidarity-card-passport__text"
                        >
                            <FormattedText value="hireSolidarityCard-modifyCharityBoxDescriptionTwo" />
                        </OKSectionBox>
                    </div>
                    <div className="col-xs-4">
                        <img
                            className="modify-solidarity-card-passport__img"
                            src={thirdIcon}
                        ></img>
                        <OKSectionBox
                            title={
                                <span className="modify-solidarity-card-passport__title">
                                    <FormattedText value="hireSolidarityCard-modifyCharityBoxTitleThree" />
                                </span>
                            }
                            hasShadow={false}
                            className="modify-solidarity-card-passport__text"
                        >
                            <FormattedText value="hireSolidarityCard-modifyCharityBoxDescriptionThree" />
                        </OKSectionBox>
                    </div>
                </div>
                <div className="modify-solidarity-card-passport__separator"></div>

                <OKLoadingErrorMessage
                    isLoading={this.props.isFetching}
                    isError={this.props.isError}
                >
                    <OkNgoSearcher
                        selected={ngosSelected}
                        userToken={token}
                        onClickCallBack={this.handleNGOList}
                        formatText={formatText}
                        FormattedText={FormattedText}
                        country={originCountry}
                        isContactCenter={__CONTACT_CENTER__}
                        environmentConfig={environmentConfig.baseHost}
                        interactionId={interactionId}
                        context={CARD}
                    />
                </OKLoadingErrorMessage>
            </Fragment>
        );
    }
}

ModifyCharityCardDataPassport.propTypes = {
    ngos: PropTypes.array,
    isFetching: PropTypes.bool,
    isError: PropTypes.bool,
    setNGOsData: PropTypes.func,
    originCountry: PropTypes.string,
    newNGOCard: PropTypes.bool,
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
};

module.exports.ModifyCharityCardDataPassport = connect(
    state => ({
        originCountry: state.profile.get("originCountry")
    }),
    {
        setNGOsData
    }
)(ModifyCharityCardDataPassport);
